module.exports = __webpack_public_path__ + "static/media/web.76bbe32d.config";